/* src/app/shared/garmin-box/garmin-box.component.scss */
.garminwidget {
  padding: 0 10px 10px 10px;
  border-radius: 20px;
}
.garminwidget2 {
  padding: 0 10px 10px 10px;
  border-radius: 20px;
  background:
    linear-gradient(
      90deg,
      rgb(255, 92, 168) 0%,
      #DE3163 100%);
}
.run,
.virtualrun,
.yoga {
  background:
    linear-gradient(
      90deg,
      rgb(255, 177, 0) 0%,
      #db7700 100%);
}
.walk,
.snowshoe,
.golf,
.soccer {
  background:
    linear-gradient(
      90deg,
      lime 0%,
      #16b800 100%);
}
.ride,
.virtualride,
.velomobile,
.ebikeride,
.handcycle,
.wheelchair {
  background:
    linear-gradient(
      90deg,
      rgb(1, 228, 31) 0%,
      #16b800 100%);
}
.swim,
.kitesurf,
.sail,
.surfing,
.windsurf {
  background:
    linear-gradient(
      90deg,
      rgb(111, 220, 255) 0%,
      #2a7efc 100%);
}
.workout,
.weighttraining,
.hike,
.elliptical,
.crossfit {
  background:
    linear-gradient(
      90deg,
      rgb(255, 81, 81) 0%,
      red 100%);
}
.elliptical,
.rowing,
.stairstepper,
.standuppaddling {
  background:
    linear-gradient(
      90deg,
      darkred 0%,
      rgb(128, 35, 35) 100%);
}
.canoeing,
.kayaking {
  background:
    linear-gradient(
      90deg,
      rgb(0, 0, 80) 0%,
      rgb(0, 49, 139) 100%);
}
.rockclimbing,
.hike {
  background:
    linear-gradient(
      90deg,
      rgb(194, 110, 0) 0%,
      rgb(119, 67, 0) 100%);
}
.alpineski,
.backcountryski,
.snowboard,
.nordicski,
.rollerski,
.iceskate,
.inlineskate,
.skateboard {
  background:
    linear-gradient(
      90deg,
      gray 0%,
      rgb(58, 58, 58) 100%);
}
.garminDistance {
  color: white;
  position: absolute;
  margin: auto;
  font-size: xxx-large;
  text-transform: uppercase;
  word-spacing: 100vw;
  max-width: 50%;
  text-align: center;
  padding-right: 9%;
  line-height: 1;
}
.topLine {
  margin: 0;
  float: left;
  color: black;
  padding-top: 5px;
  max-width: 90%;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.columnDark {
  color: black;
  text-align: justify;
  text-transform: uppercase;
  font-size: small;
}
.columnWhite {
  padding-left: 5px;
  text-align: right;
  font-weight: bold;
  color: white;
}
/*# sourceMappingURL=garmin-box.component.css.map */
